<app-user-slideout [loading]="loading" [user]="user">
  <div class="datagrid-title">{{ 'admin.userTable.headers.organisations' | translate }}</div>
  <div class="datagrid-content">
    <ul class="list-group list-group-flush">
      @for (org of user?.organisations; track org) {
        <li class="list-group-item">
          {{ org.name }}
        </li>
      }
    </ul>
  </div>
</app-user-slideout>